import React from 'react';

const EmojiListItem = ({ data }) => {
    return (
        <div className='emoji-list-item'>
            <img className={`emoji emoji-spin-${data.emoji.spin}`} src={data.emoji.image.url} alt={data.emoji.image.alt} />
            <div className='emoji-list-item-text'>
                <h5>{data.title}</h5>
                <p>{data.body}</p>
            </div>
        </div>
    )
}
export default EmojiListItem